import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import { states } from '@/constants/lifecycle';
import CreateButton from '@/components/buttons/CreateButton';
import EditButton from '@/components/buttons/EditButton';
import RemoveButton from '@/components/buttons/RemoveButton';
import LookupsButton from '../../lookups/components/LookupsButton';
import {
  deleteActiveDictionary,
  showDictionaryLookups,
  showEditDictionary,
} from '../actions';
import { datasetPerms } from '../../sharing/state/state';
import { canEditDataset } from '../../helper';
import { resolveCatalogueTemplate } from '../../catalogue/helper';
import DictionaryValidationResultButton from '../../data/components/DictionaryValidationResultButton';
import { showDictionaryReport } from '../../reports/actions';
import { dictionaryReportTypes } from '../../reports/constants';
import DictionaryMarkdownButton from '../markdown/components/DictionaryMarkdownButton';

const DictionaryButtons = ({
  canDownload,
  canEdit,
  category,
  code,
  dataExists,
  deleteDictionary,
  dictionaries,
  dictionaryCode,
  dictionaryUUID,
  disabled,
  managedData,
  rowCount,
  showDictionaryDialog,
  showLookupsDialog,
  showValidationReport,
  template,
  validationDate,
  validationReportId,
  validationStatus,
}) => (
  <Button.Group
    icon
    compact
    floated="right"
    size="small"
    className="aridhia-dictionary-buttons"
  >
    {canEdit && (
    <>
      <EditButton
        entity="dictionary"
        onClick={() => showDictionaryDialog(category, code, dictionaryUUID, false)}
        disabled={dictionaries.length === 0 || disabled}
      />
      <CreateButton
        entity="dictionary"
        onClick={() => showDictionaryDialog(category, code, null, true)}
        disabled={disabled}
      />
      <RemoveButton
        entity="dictionary"
        onClick={() => deleteDictionary(category, code, dictionaryUUID, template)}
        disabled={dictionaries.length === 0 || disabled}
      />
    </>
    )}
    <LookupsButton
      onClick={() => showLookupsDialog(category, code, null, canEdit)}
      disabled={dictionaries.length === 0 || disabled}
    />
    {canDownload && (
    <DictionaryMarkdownButton
      code={code}
      dictionaryCode={dictionaryCode}
      disabled={dictionaries.length === 0 || disabled}
    />
    )}
    {canEdit && managedData && (
    <DictionaryValidationResultButton
      onClick={() => showValidationReport(
        'downloads',
        dictionaryCode,
        dictionaryReportTypes.VALIDATION,
        validationReportId,
      )}
      disabled={dictionaries.length === 0 || disabled || !validationDate}
      validationStatus={validationStatus}
      validationDate={validationDate}
      rowCount={rowCount}
      dataExists={dataExists}
    />
    )}
  </Button.Group>
);

const mapStateToProps = ({
  auth: { role },
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    dictionaries: [],
    permissions: datasetPerms(),
    uploadStatus: states.PENDING,
    activeDictionaryUUID: null,
  });
  const activeDictionary = findWithUUID(dataset.dictionaries, dataset.activeDictionaryUUID);
  const dictionaryStatus = activeDictionary?.status || {};
  const {
    last_validation_status: validationStatus,
    last_validation_at: validationDate,
    last_validation_report: validationReportId,
    row_count: rowCount,
    data_exists: dataExists,
  } = dictionaryStatus;

  return (
    {
      canDownload: role.permissions.datasets.download,
      canEdit: canEditDataset(dataset, role),
      dataExists,
      dictionaries: dataset.dictionaries,
      dictionaryCode: activeDictionary?.code,
      dictionaryUUID: dataset.activeDictionaryUUID,
      disabled: dataset.uploadStatus === states.PENDING
          || dataset.attachments.uploadStatus === states.PENDING,
      managedData: dataset?.status?.managed_data?.supported,
      rowCount,
      template,
      validationStatus,
      validationDate,
      validationReportId,
    }
  );
};

const mapDispatchToProps = {
  showLookupsDialog: showDictionaryLookups,
  deleteDictionary: deleteActiveDictionary,
  showDictionaryDialog: showEditDictionary,
  showValidationReport: showDictionaryReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryButtons);
